import { Box, Typography, useTheme } from '@mui/material';
import type { ISkillReferenceDTO } from '@sharedInterfaces/ISkill';
import type Employee from '@src/Objects/Employee';
import React from 'react';

import EmployeeOverviewTiles from '../../EmployeeOverviewTiles';
import CertificatesCardWidget from './components/CertificatesCardWidget';
import LearningPathWidget from './components/LearningPathWidget';
import MissionsCardWidget from './components/MissionsCardWidget';
import QuickLinksWidgetNew from './components/QuickLinksWidgetNew';
import SkillManagerCardWidget from './components/SkillManagerCardWidget';
import SuperPowersCardWidget from './components/SuperPowersCardWidget';

interface MyProfileOverviewProps {
    employee: Employee;
    onTabChange: (tabIndex: number) => void;
    currentSuperPowers?: ISkillReferenceDTO[];
    setCurrentSuperPowers?: React.Dispatch<React.SetStateAction<ISkillReferenceDTO[]>>;
}

function MyProfileOverview({
    employee,
    onTabChange,
    currentSuperPowers,
    setCurrentSuperPowers,
}: MyProfileOverviewProps) {
    const theme = useTheme();
    // const lang = useSelector((state: AppState) => state.employee.language);
    // const langStrings = getLanguageTexts(lang);

    // Mock project data
    // const mockProjects = [
    //     {
    //         id: 1,
    //         title: 'E-Commerce Platform Redesign',
    //         client: 'TechCorp GmbH',
    //         role: 'Frontend Developer',
    //         icon: ShoppingCart,
    //         color: theme.palette.primary.main,
    //         active: true,
    //     },
    //     {
    //         id: 2,
    //         title: 'Mobile Banking App',
    //         client: 'FinanceBank AG',
    //         role: 'React Native Developer',
    //         icon: Smartphone,
    //         color: theme.palette.primary.main,
    //         active: true,
    //     },
    // ];

    return (
        <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: theme.palette.primary.main }}>
                Mein Profil
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: 2, md: 3 },
                }}
            >
                {/* Overview Tiles */}
                <EmployeeOverviewTiles employee={employee} />

                {/* First Row - Card Widgets */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: { xs: 2, md: 3 },
                    }}
                >
                    <SuperPowersCardWidget
                        employee={employee}
                        onTabChange={onTabChange}
                        currentSuperPowers={currentSuperPowers}
                        setCurrentSuperPowers={setCurrentSuperPowers}
                    />
                    <CertificatesCardWidget employee={employee} onTabChange={onTabChange} />
                    <SkillManagerCardWidget employee={employee} onTabChange={onTabChange} />
                    <MissionsCardWidget employee={employee} onTabChange={onTabChange} />
                </Box>

                {/* Second Row - Learning Path */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: { xs: 2, md: 3 },
                    }}
                >
                    <LearningPathWidget onTabChange={onTabChange} />
                </Box>

                {/* Skill Recommendations Gallery - Full Width */}
                {/* <SkillRecommendationsGallery /> */}

                {/* Quick Links Widget - Full Width */}
                <QuickLinksWidgetNew
                    employee={employee}
                    onTabChange={onTabChange}
                    tabContext="overview"
                    layoutMode="horizontal"
                />
            </Box>
        </Box>
    );
}

export default MyProfileOverview;
